const getTokenLogoURL = (address: string) => `https://milkomeda.muesliswap.com/images/tokens/${address}.png`

// FIXME: Why the hell did pancakeswap use trust wallet here?

export default getTokenLogoURL
